import React from 'react';
import { useForm } from 'react-hook-form';
import {
  ContractElement,
  ElementDesc,
  ElementHeader,
  ElementInput,
  ContractForm,
} from '../contractElements';
import { CarbonButton } from '../../../Utils/generalStyles';

const mintForAddress = ({ onSumbit }) => {
  const { register, handleSubmit } = useForm();
  return (
    <ContractElement>
      <ElementHeader>Mint for address</ElementHeader>
      <ElementDesc>Mint NFT to given address with given amount (OnlyTeam)</ElementDesc>
      <ContractForm onSubmit={handleSubmit(onSumbit)}>
        <ElementInput
          {...register('address')}
          bottom="25px"
          placeholder="Address"
          type="text"
        />
        <ElementInput
          {...register('amount')}
          bottom="25px"
          placeholder="Amount"
          type="number"
          name="amount"
        />
        <CarbonButton colored type="submit">Submit</CarbonButton>
      </ContractForm>
    </ContractElement>
  );
};

export default mintForAddress;
